import { createThunkRoutine } from 'redux-thunk-routine';
import {
  FETCH_STATS_DATA,
  FETCH_DATASETS_DATA,
  FETCH_SIMULATIONS_DATA
} from './action-types';

export const FetchStatsRoutine = createThunkRoutine(FETCH_STATS_DATA);
export const FetchDatasetsRoutine = createThunkRoutine(FETCH_DATASETS_DATA);
export const FetchSimulationsRoutine = createThunkRoutine(FETCH_SIMULATIONS_DATA);
